import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Sofía M.',
  location: 'Buenos Aires',
  role: 'Instructora de Pilates en Estudio Propio',
  quote: 'Compré un domingo a la noche. El lunes entré al estudio con el plan exacto de la clase. Las clases del Tomo 1 son exactamente lo que necesitaba para mis grupos de principiantes. Nunca más improviso.'
}, {
  name: 'Carolina R.',
  location: 'Rosario',
  role: 'Instructora en Centro de Adultos Mayores',
  quote: 'El Tomo V, el de Pilates Suave, me cambió todo. El primer mes, alumnas que llevaban meses estancadas mejoraron visiblemente su movilidad y su equilibrio. El protocolo de seguridad me da la tranquilidad que antes no tenía.'
}, {
  name: 'Valentina F.',
  location: 'Córdoba',
  role: 'Instructora de Pilates Grupal e Individual',
  quote: 'El sistema de Flow del Tomo III es único en el mercado. 10 clases de flow listas para usar, con las transiciones descriptas paso a paso. Antes tardaba horas armando una secuencia. Ahora abro el PDF y en 5 minutos tengo todo listo.'
}, {
  name: 'Luciana P.',
  location: 'Tucumán',
  role: 'Instructora Particular y en Gimnasio',
  quote: 'La Guía de Variaciones en 3 Niveles eliminó el problema del grupo heterogéneo. Ahora muestro las 3 versiones de cada ejercicio y cada alumna elige la que le corresponde. Las alumnas avanzadas se sienten desafiadas y las principiantes se sienten seguras.'
}, {
  name: 'Marcela G.',
  location: 'Mendoza',
  role: 'Instructora de Pilates Online y Presencial',
  quote: 'La tasa de abandono de mis grupos bajó muchísimo. Sin cambiar lo que enseño. Solo aplicando el sistema de progresión mensual del calendario y la variedad de los 6 tomos. Las alumnas ahora quieren venir porque siempre hay algo nuevo.'
}, {
  name: 'Laura V.',
  location: 'Santa Fe',
  role: 'Instructora de Pilates en Estudio Propio',
  quote: 'El Script de Primera Clase del Bono 5 me salvó de perder alumnas que venían a probar. Ahora sé exactamente qué decir en cada momento. Mi tasa de conversión de primera clase a pack mensual subió de manera notable.'
}, {
  name: 'Ana R.',
  location: 'Salta',
  role: 'Instructora en Centro de Salud',
  quote: 'El Safe Pilates Pro me cambió la cabeza. Nunca había dimensionado el riesgo que corría sin adaptaciones claras para mis alumnas con condiciones especiales. Ahora trabajo con una tranquilidad que antes no tenía.'
}];
export const TestimonialsFull = () => {
  return <section className="py-8 md:py-14 bg-white" data-id="element-335">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-336">
        <div className="text-center mb-8 md:mb-16" data-id="element-337">
          <h2 className="text-2xl md:text-5xl font-bold text-charcoal font-playfair mb-2 md:mb-4" data-id="element-338">
            Lo que dicen las instructoras que ya lo usan:
          </h2>
          <p className="text-base md:text-xl text-sage font-medium" data-id="element-339">
            +500 instructoras de Pilates de todo el país ya tienen su PILATES
            360
          </p>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-4 md:gap-8 space-y-4 md:space-y-8" data-id="element-340">
          {testimonials.map((test, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index % 3 * 0.1
        }} className="break-inside-avoid bg-offwhite p-5 md:p-8 rounded-xl md:rounded-2xl border border-gray-100 shadow-sm" data-id="element-341">
              <div className="flex gap-0.5 mb-2 md:mb-4" data-id="element-342">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 md:w-4 md:h-4 fill-gold text-gold" data-id="element-343" />)}
              </div>
              <p className="text-sm text-gray-700 italic mb-4 md:mb-6 leading-relaxed" data-id="element-344">
                "{test.quote}"
              </p>
              <div data-id="element-345">
                <p className="font-bold text-charcoal text-sm" data-id="element-346">{test.name}</p>
                <p className="text-xs text-sage font-medium flex items-center gap-1" data-id="element-347">
                  📍 {test.location}
                </p>
                <p className="text-[10px] text-gray-500 mt-0.5" data-id="element-348">{test.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};